import Command from "@ckeditor/ckeditor5-core/src/command"

export default class InsertRecommendBox extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(this.createRecommendBox(writer))
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "recommendBox"
    )

    this.isEnabled = allowedIn !== null
  }

  createRecommendBox(writer) {
    const box = writer.createElement("recommendBox")
    const label = writer.createElement("recommendBoxLabel")
    const errorLabel = writer.createElement("recommendBoxErrorLabel")
    const isbn = writer.createElement("recommendBoxISBN")

    // label
    writer.append(label, box)
    writer.appendText("ISBN", label)

    // error label
    writer.append(errorLabel, box)
    writer.appendText("フォーマットが不正です", errorLabel)

    // isbn
    writer.append(isbn, box)

    return box
  }
}
